import React from 'react';

import {fieldHelpStyle, fieldLabelStyle, lockedValueStyle} from '../lib/formStyles.js';

// ============================================================================
// LockedValue — a locked or calculated value (Design Constitution I09)
// ----------------------------------------------------------------------------
// The label, the value as plain bold text and a small gray note saying where it
// comes from ('From the last weigh-in'). Never an input-shaped box.
// ============================================================================

type LockedValueProps = {
  label: React.ReactNode;
  value: React.ReactNode;
  source?: React.ReactNode;
  style?: React.CSSProperties;
};

export default function LockedValue({label, value, source, style}: LockedValueProps) {
  return (
    <div data-locked-value="1" style={style}>
      <div style={fieldLabelStyle}>{label}</div>
      <div style={lockedValueStyle}>{value}</div>
      {source && <div style={{...fieldHelpStyle, marginTop: 2}}>{source}</div>}
    </div>
  );
}
